import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["notification"]

  static values = { wait: Number }

  connect() {
    var _this = this

    if (typeof Intercom == "undefined" || document.getElementById("intercom-frame") === null) {
      return
    }

    setTimeout(function () {
      _this.notificationTarget.style.display = "block"
    }, _this.waitValue * 1000)

    Intercom("onHide", function () {
      _this.notificationTarget.style.display = "block"
    })

    Intercom("onShow", function () {
      _this.notificationTarget.style.display = "none"
    })
  }

  launchChat() {
    this.notificationTarget.style.display = "none"
    Intercom("showNewMessage")
  }
}
